/* Layout is just a UI wrapper that could eventually be used for responsive stuff */

export default function Layout({
	children
}) {
	return <div className="Layout">{children}</div>
}